module.exports = __webpack_public_path__ + "img/industrial_case.e4f397da.png";